import React, { useState } from 'react';
import { refundTransaction } from '../../services/financeService';

const RefundModal = ({ transaction, onClose, onRefund }) => {
  const [description, setDescription] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description) {
      setError('Por favor, introduce una descripción para el reembolso.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await refundTransaction(transaction.id, description);
      onRefund();
    } catch (err) {
      setError('Error al procesar el reembolso. Inténtalo de nuevo.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Confirmar Reembolso</h2>
        <p>Estás a punto de reembolsar la siguiente transacción:</p>
        <ul>
          <li><strong>ID:</strong> {transaction.id}</li>
          <li><strong>Monto:</strong> ${transaction.amount.toFixed(2)}</li>
          <li><strong>Descripción Original:</strong> {transaction.description}</li>
        </ul>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="refund-description">Motivo del Reembolso</label>
            <input
              type="text"
              id="refund-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Ej: Cargo incorrecto"
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" disabled={loading}>
              {loading ? 'Procesando...' : 'Confirmar Reembolso'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RefundModal;